import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { OverlayService } from '../../../services/overlay.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter, debounceTime } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';

@Component({
	selector: 'app-fade',
	templateUrl: './fade.component.html',
	styleUrls: ['./fade.component.scss']
})
export class FadeComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('fadeForm', { static: true }) fadeForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	fadeFormSubscription: Subscription;
	image3Invalid = false;
	image4Invalid = false;
	image5Invalid = false;
	showImage3 = false;
	showImage4 = false;
	showImage5 = false;
	showImageButton2 = true;
	showImageButton3 = false;
	showImageButton4 = false;
	showImageButton5 = false;
	isAdmin;

	constructor(private auth: AuthService, private cs: ComponentService, private overlay: OverlayService) {}

	ngOnInit() {
		this.isAdmin = this.auth.isAdmin();
		this.fadeFormSubscription = this.fadeForm.valueChanges
			.pipe(
				tap(() => this.cs.updateDisabledSave((this.fadeForm.dirty && this.fadeForm.invalid) || this.nameField.editComponentName)),
				filter((formData) => Boolean(this.fadeForm.dirty && this.fadeForm.valid)),
				debounceTime(2000)
			)
			.subscribe();

		if (this.componentData.config.images[4]) {
			this.showImageButton2 = false;
			this.showImage3 = true;
			this.showImage4 = true;
			this.showImage5 = true;
		} else if (this.componentData.config.images[3]) {
			this.showImageButton2 = false;
			this.showImageButton4 = true;
			this.showImage3 = true;
			this.showImage4 = true;
		} else if (this.componentData.config.images[2]) {
			this.showImageButton2 = false;
			this.showImageButton3 = true;
			this.showImage3 = true;
		}
	}

	ngOnDestroy() {
		this.fadeFormSubscription.unsubscribe();
	}

	addImage(item) {
		if (item == 3) {
			this.showImage3 = true;
			this.showImageButton2 = false;
			this.showImageButton3 = true;
		}
		if (item == 4) {
			this.showImage4 = true;
			this.showImageButton3 = false;
			this.showImageButton4 = true;
		}
		if (item == 5) {
			this.showImage5 = true;
			this.showImageButton4 = false;
		}
	}

	removeImage(item) {
		if (item == 3) {
			this.showImage3 = false;
			this.showImageButton2 = true;
			this.showImageButton3 = false;
			if (this.componentData.config.images[2]) {
				this.componentData.config.images[2] = null;
			}
		}
		if (item == 4) {
			this.showImage4 = false;
			this.showImageButton3 = true;
			this.showImageButton4 = false;
			if (this.componentData.config.images[3]) {
				this.componentData.config.images[3] = null;
			}
		}
		if (item == 5) {
			this.showImage5 = false;
			this.showImageButton4 = true;
			if (this.componentData.config.images[4]) {
				this.componentData.config.images[4] = null;
			}
		}
	}

	optionalImageAdd(index: number, event: any): void {
		var optionalErrorMsg = 'Please Add the Optional Images in Order.';

		if (index == 3) {
			if (event) {
				if (!this.componentData.config.images[3] && this.componentData.config.images[4]) {
					this.cs.updateDisabledSave(true);
					this.image3Invalid = false;
					this.image4Invalid = true;
					optionalErrorMsg = optionalErrorMsg + ' Missing Optional Image 4.';
					this.overlay.updateOverlay(true, optionalErrorMsg, 'alert');
				} else {
					this.cs.updateDisabledSave(false);
					this.image3Invalid = false;
					this.image4Invalid = false;
					this.image5Invalid = false;
				}
			} else {
				if (!this.componentData.config.images[3] && !this.componentData.config.images[4]) {
					this.cs.updateDisabledSave(false);
					this.image3Invalid = false;
					this.image4Invalid = false;
					this.image5Invalid = false;
				} else if (!this.componentData.config.images[3] || !this.componentData.config.images[4]) {
					this.cs.updateDisabledSave(true);
					this.image3Invalid = true;
					if (!this.componentData.config.images[3]) {
						this.image4Invalid = true;
					}
					this.overlay.updateOverlay(true, optionalErrorMsg, 'alert');
				} else if (this.componentData.config.images[3] && this.componentData.config.images[4]) {
					this.cs.updateDisabledSave(true);
					this.image3Invalid = true;
					optionalErrorMsg = optionalErrorMsg + ' Missing Optional Image 3.';
					this.overlay.updateOverlay(true, optionalErrorMsg, 'alert');
				} else {
					this.cs.updateDisabledSave(false);
					this.image3Invalid = false;
				}
			}
		}

		if (index == 4) {
			if (event) {
				if (!this.componentData.config.images[2]) {
					this.cs.updateDisabledSave(true);
					this.image3Invalid = true;
					this.image4Invalid = false;
					this.image5Invalid = false;
					optionalErrorMsg = optionalErrorMsg + ' Missing Optional Image 3.';
					this.overlay.updateOverlay(true, optionalErrorMsg, 'alert');
				} else {
					this.cs.updateDisabledSave(false);
					this.image3Invalid = false;
					this.image4Invalid = false;
					this.image5Invalid = false;
				}
			} else {
				if (!this.componentData.config.images[2] && !this.componentData.config.images[4]) {
					this.cs.updateDisabledSave(false);
					this.image3Invalid = false;
					this.image4Invalid = false;
					this.image5Invalid = false;
				} else if (!this.componentData.config.images[2] && this.componentData.config.images[4]) {
					this.cs.updateDisabledSave(true);
					this.image3Invalid = true;
					this.image4Invalid = true;
					this.overlay.updateOverlay(true, optionalErrorMsg, 'alert');
				} else if (this.componentData.config.images[2] && this.componentData.config.images[4]) {
					this.cs.updateDisabledSave(true);
					this.image3Invalid = false;
					this.image4Invalid = true;
					this.image5Invalid = false;
					optionalErrorMsg = optionalErrorMsg + ' Missing Optional Image 4.';
					this.overlay.updateOverlay(true, optionalErrorMsg, 'alert');
				} else {
					this.cs.updateDisabledSave(false);
					this.image4Invalid = false;
				}
			}
		}

		if (index == 5) {
			if (event) {
				if (!this.componentData.config.images[2] && !this.componentData.config.images[3]) {
					this.cs.updateDisabledSave(true);
					this.image3Invalid = true;
					this.image4Invalid = true;
					this.image5Invalid = false;
					optionalErrorMsg = optionalErrorMsg + ' Missing Optional Image 3 and 4.';
					this.overlay.updateOverlay(true, optionalErrorMsg, 'alert');
				} else if (!this.componentData.config.images[2] && this.componentData.config.images[3]) {
					this.cs.updateDisabledSave(true);
					this.image3Invalid = true;
					this.image4Invalid = false;
					this.image5Invalid = false;
					optionalErrorMsg = optionalErrorMsg + ' Missing Optional Image 3.';
					this.overlay.updateOverlay(true, optionalErrorMsg, 'alert');
				} else if (this.componentData.config.images[2] && !this.componentData.config.images[3]) {
					this.cs.updateDisabledSave(true);
					this.image3Invalid = false;
					this.image4Invalid = true;
					this.image5Invalid = false;
					optionalErrorMsg = optionalErrorMsg + ' Missing Optional Image 4.';
					this.overlay.updateOverlay(true, optionalErrorMsg, 'alert');
				} else {
					this.cs.updateDisabledSave(false);
					this.image3Invalid = false;
					this.image4Invalid = false;
					this.image5Invalid = false;
				}
			} else {
				if (!this.componentData.config.images[2] && this.componentData.config.images[3]) {
					this.cs.updateDisabledSave(true);
					this.image3Invalid = true;
					this.image4Invalid = false;
					this.image5Invalid = false;
					optionalErrorMsg = optionalErrorMsg + ' Missing Optional Image 3.';
					this.overlay.updateOverlay(true, optionalErrorMsg, 'alert');
				} else {
					this.cs.updateDisabledSave(false);
					this.image3Invalid = false;
					this.image4Invalid = false;
					this.image5Invalid = false;
				}
			}
		}
	}

	brodcastToPreview() {
		this.cs.updateComponentData(this.componentData);
		this.cs.updatePreviewData();
	}
}
